export function AbstractAjaxForm()
{
    const self = this;

    // Discourage instantiating this class
    // The script won't break, so throwing an Error is not needed
    if (self.constructor === AbstractAjaxForm) {
        console.error('AbstractAjaxForm should not be instantiated, use a subclass instead.');
    }

    /**
     * The CSS selector of the form(s) to convert
     * @type {String|null}
     */
    self.formSelector = null;

    /**
     * Prevent form submission, use Ajax instead
     * @return {void}
     */
    self.captureSubmit = () => {
        // A selector is needed
        if (self.formSelector === null) {
            return;
        }

        $('body').on('submit', self.formSelector, event => {
            event.preventDefault();

            // Get the form attributes
            const $form = $(event.target);
            const action = $form.attr('action');
            const method = $form.find('[name="_method"]').val() || $form.attr('method') || 'POST';

            self.beforeCall($form);

            // Do an Ajax call instead of normal submitting
            $.ajax(action, {
                method,
                dataType: 'json',
                data: $form.serializeArray(),
            }).then(response => {
                self.handleResponse(response, $form);
            });
        });
    };

    /**
     * Actions to perform before doing the Ajax call
     * @param {jQuery} $form The form to be submitted
     * @return {void}
     */
    self.beforeCall = $form => {
    };

    /**
     * Handle the response from the Ajax call
     * @param {Object} response
     * @param {jQuery} $form The form that was submitted
     * @return {void}
     */
    self.handleResponse = (response, $form) => {
    };
}



// WEBPACK FOOTER //
// ./resources/js/MrMovie/AbstractAjaxForm.js